import { render, staticRenderFns } from "./CampaignModal.vue?vue&type=template&id=28c836ec"
import script from "./CampaignModal.vue?vue&type=script&lang=js"
export * from "./CampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports